import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useForm } from 'react-hook-form';
import { GridForm } from 'components/Ui/styled';
import { getDialogHeading } from 'utils/commonUtils';
import { PaperPropsWithoutScrollbar } from 'constants';
import { SignaturePair } from '../../spedNotesCommonUtils';
import { FormInputText } from 'components/Common/Forms/FormTextField';

const BulkSignOffNoteViewDialog = (props) => {
  const { open, setOpen, spedNoteForm, setSpedNoteForm } = props;

  const {
    notes,
    location,
    esignature,
    serviceDate,
    serviceType,
    sessionStatus,
    seifEsignature,
    serviceProvider,
    genEdEsignature,
    noteSignatureAgree,
    seifSignatureAgree,
    genEdSignatureAgree,
    serviceDurationMinutes,
  } = spedNoteForm || {};

  const parseServiceDateTime = (dateTimeString) => {
    if (!dateTimeString) {
      return { date: '', time: '' };
    }

    const [datePart, timePart] = dateTimeString.split(' at ');

    return {
      date: datePart || '',
      time: timePart || '',
    };
  };

  const { date: formattedDate, time: formattedTime } =
    parseServiceDateTime(serviceDate);

  const defaultValue = {
    notes: notes || '',
    location: location || '',
    serviceDate: formattedDate,
    serviceTime: formattedTime,
    esignature: esignature || '',
    serviceType: serviceType || '',
    sessionStatus: sessionStatus || '',
    seifEsignature: seifEsignature || '',
    genEdEsignature: genEdEsignature || '',
    serviceProvider: serviceProvider || '',
    seifSignatureAgree: seifSignatureAgree,
    noteSignatureAgree: noteSignatureAgree,
    studentId: spedNoteForm?.studentId || '',
    genEdSignatureAgree: genEdSignatureAgree,
    serviceDurationMinutes: serviceDurationMinutes,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { reset, control } = useFunction;

  useEffect(() => {
    if (open) {
      reset(defaultValue);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
    setSpedNoteForm({});
  };

  return (
    <>
      <Dialog open={open} PaperProps={PaperPropsWithoutScrollbar}>
        {getDialogHeading('SPED Note', handleClose)}

        <GridForm container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormInputText
              readOnly={true}
              name="studentId"
              control={control}
              label="Student ID"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormInputText
              readOnly={true}
              control={control}
              name="serviceDate"
              label="Service Date"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormInputText
              shrink={true}
              readOnly={true}
              control={control}
              name="serviceTime"
              label="Service Time"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormInputText
              type="number"
              readOnly={true}
              control={control}
              name="serviceDurationMinutes"
              label="Service Duration (minutes)"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormInputText
              readOnly={true}
              name="location"
              label="Location"
              control={control}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormInputText
              readOnly={true}
              control={control}
              name="serviceProvider"
              label="Service Provider"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormInputText
              readOnly={true}
              control={control}
              name="sessionStatus"
              label="Session Status"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormInputText
              readOnly={true}
              control={control}
              name="serviceType"
              label="Service Type"
            />
          </Grid>

          <Grid item xs={12}>
            <FormInputText
              rows={2}
              name="notes"
              label="Notes"
              readOnly={true}
              multiline={true}
              control={control}
            />
          </Grid>

          <SignaturePair
            readOnly={true}
            control={control}
            inputName="esignature"
            checkboxName="noteSignatureAgree"
            inputLabel="SPED Provider Signature"
            inputPlaceholder="SPED Provider Signature full name"
          />

          <SignaturePair
            readOnly={true}
            control={control}
            inputName="genEdEsignature"
            checkboxName="genEdSignatureAgree"
            inputPlaceholder="Gen Ed teacher's full name"
            inputLabel="Gen Ed Teacher Signature (optional)"
          />
          <Grid item xs={12} sm={6}></Grid>
        </GridForm>
      </Dialog>
    </>
  );
};

export default BulkSignOffNoteViewDialog;
